import { useNetworkStatus } from "shared";

export const useOffline = () => {
    const { isOnline } = useNetworkStatus();

    const onOfflineReload = () => {
        if (isOnline) window.location.reload();
        else alert("Still offline. Please check your internet connection.");
    };

    return { isOnline, onOfflineReload };
};
